import "~/misc/common";
import { p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";

import { SnowStorm } from '~/misc/snowstorm';

export default class extends Controller {
  connect() {
    p('initHome');
    const monthNumber = new Date().getMonth() + 1;
    const el = this.element as HTMLElement;
    const bg = el.dataset.bg!;
    const fs = el.dataset.fs;
    if (monthNumber == 12) {
      $('body').css('background', bg);
      const snow = new SnowStorm({
        flakesMax: 128,
        flakesMaxActive: 64,
        useGPU: true,
        snowColor: '#fff'
      });
      snow.start();
    }

    if (fs) {
      $('body').css('height', '100%');
      $('html').css('height', '100%');
      //$('body').css('min-height', '100%');
      //$('html').css('min-height', '100%');
      $('.full-map-header>nav').css('margin-bottom', '0px');
    }
  }
}